import { CurrencyContextProvider } from 'pricing-pages-ui/context/CurrencyContext';
import { PublicDerivedCohortInfoProvider } from 'pricing-pages-ui/context/DerivedCohortInfoContext';
import { ExperimentProvider } from 'pricing-pages-ui/context/ExperimentContext';
import { GlobalLoadingStateContextProvider } from 'pricing-pages-ui/context/GlobalLoadingStateContext';
import { PublicI18nContext } from 'pricing-pages-ui/context/I18nContext';
import { jsx as _jsx } from "react/jsx-runtime";
/*
 * Mounts in-app (pricing-pages-ui) providers kept alive while page components
 * still consume pricing-pages-ui contexts. Delete this file and its call site
 * in PublicApp.tsx once pricing-pages-ui/Routes fully retires (#19831+).
 */
export function LegacyInAppProviders({
  i18nLoader,
  children
}) {
  return /*#__PURE__*/_jsx(ExperimentProvider, {
    children: /*#__PURE__*/_jsx(GlobalLoadingStateContextProvider, {
      children: /*#__PURE__*/_jsx(CurrencyContextProvider, {
        children: /*#__PURE__*/_jsx(PublicI18nContext.Provider, {
          value: {
            i18nLoader
          },
          children: /*#__PURE__*/_jsx(PublicDerivedCohortInfoProvider, {
            children: children
          })
        })
      })
    })
  });
}